import {  
    loadUserPermissionsRolesDataInProgress,
    loadUserPermissionsRolesDataSuccess,
    loadUserPermissionsRolesDataFailure,
    loadUserPermissionsRolesNotFound,
  } from "../state/userpermissions/actions";
import { oktaAuth } from '../auth/okta';
import { errorSweetAlert } from "../components/SweetAlertMessages";
const serverBasePath=process.env.REACT_APP_SERVER_API_URL;
  
export const getUserPermissionRolesData = () => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
        dispatch(loadUserPermissionsRolesDataInProgress());
        const response  = await fetch(serverBasePath+"/user/getUserAndRolePermissions",
        {     
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        dispatch(loadUserPermissionsRolesDataFailure());
        if(response.status !== 200){
            dispatch(loadUserPermissionsRolesNotFound(data));
            return;
        }
        dispatch(loadUserPermissionsRolesDataSuccess(data));
    } catch (e) {       
        dispatch(loadUserPermissionsRolesDataFailure());
        errorSweetAlert(e);
    }
};
  
  